var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 31H19.9998M27.9998 18C27.9998 16.4087 27.3676 14.8826 26.2424 13.7574C25.1172 12.6321 23.5911 12 21.9998 12C20.4085 12 18.8824 12.6321 17.7571 13.7574C16.6319 14.8826 15.9998 16.4087 15.9998 18C15.9998 21.0902 15.2202 23.206 14.3494 24.6054C13.6149 25.7859 13.2476 26.3761 13.2611 26.5408C13.276 26.7231 13.3146 26.7926 13.4616 26.9016C13.5942 27 14.1924 27 15.3886 27H28.6109C29.8072 27 30.4053 27 30.538 26.9016C30.6849 26.7926 30.7235 26.7231 30.7384 26.5408C30.7519 26.3761 30.3846 25.7859 29.6501 24.6054C28.7793 23.206 27.9998 21.0902 27.9998 18Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 8,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#E73751"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 8,
    width: 8,
    height: 8,
    rx: 4,
    stroke: "#004B6C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.c8d4c287718016a312cc4ebf15064471.svg";
export { ForwardRef as ReactComponent };